import Modal from '@components/v2/ui/Modal/Modal';
import { useMemo } from 'react';
import LangEnum from '../../../../lang/LangEnum';
import { useGetOrderPaymentHistory } from '../../../../services/modules/order/order.queries';
import { useTranslation } from '../../../translation/TranslationContext';
import OrderPaymentHistoryModalContent from './components/OrderPaymentHistoryModalContent';

interface OrderHistoricProps {
  isOpen: boolean;
  setClose: () => void;
  orderId: string;
}

const OrderPaymentHistoryModal = ({ isOpen, setClose, orderId }: OrderHistoricProps) => {
  const { translate } = useTranslation();

  const { data, isLoading } = useGetOrderPaymentHistory({
    isOpen,
    orderId,
  });

  const payments = useMemo(() => data || [], [data]);

  return (
    <Modal
      isOpen={isOpen}
      size="standard"
      header={{ title: translate(LangEnum.ORDER_PAYMENT_HISTORY_TITLE) }}
      onClose={setClose}
    >
      <OrderPaymentHistoryModalContent isLoading={isLoading} payments={payments} />
    </Modal>
  );
};

export default OrderPaymentHistoryModal;
